import React from 'react';
import { motion } from 'framer-motion';
import { PersonSchema } from '../components/StructuredData';
export function FoundersAnatomyOfEndurance() {
  return <div className="min-h-screen bg-gradient-to-b from-black via-[#0a1f2e] to-black" data-id="element-614" data-mp="3bdxn06cq11e0">
      <PersonSchema name="Natalya Wallin" jobTitle="GP & Managing Director, Vitality Venture Fund" description="High-conviction leader with 10+ years deploying a $75M global fund. Backgrounds in biology and molecular genetics. Executive MBA from Duke University. Moab 240-mile ultramarathon finisher." image="https://cdn.magicpatterns.com/uploads/nPrbWRd99BLA7hL4gLSpQo/7_Natalya.jpg" url="https://www.vitalityvf.com/founders" data-id="element-615" data-mp="2xfze3gh65x5w" />

      {/* Hero */}
      <section aria-label="Founder Story: The Anatomy of Endurance" className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-616" data-mp="2irmem9ivhw6n">
        <div className="absolute inset-0" data-id="element-617" data-mp="29pmz5lnib05t">
          <img src="https://cdn.magicpatterns.com/uploads/hG6wRmeXbcpGUWshNGVPem/9_Descending_Jacobs_Ladder.jpg" alt="Natalya Wallin descending Jacob's Ladder during the Moab 240-mile ultramarathon" className="w-full h-full object-cover" data-id="element-618" data-mp="29sivj5jphgs5" />
          <div className="absolute inset-0 bg-black/70" data-id="element-619" data-mp="11vu7qwqawo19" />
        </div>

        <div className="relative z-10 text-center px-4" data-id="element-620" data-mp="x0552kizir0q">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-vitalityTeal text-sm font-bold tracking-wider uppercase mb-4" data-id="element-621" data-mp="98zou494twpw">
            Founder Story: The Anatomy of Endurance
          </motion.p>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="text-6xl md:text-8xl font-bold text-white mb-8" data-id="element-622" data-mp="3mn452101o2bg">
            What does it take?
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="text-2xl text-gray-400 max-w-3xl mx-auto" data-id="element-623" data-mp="1vcsid98ekudi">
            To run 240 miles. To build the almost impossible.
          </motion.p>
        </div>
      </section>

      {/* Trait 1: Conviction */}
      <article aria-label="Trait: Conviction" className="min-h-screen grid lg:grid-cols-2 items-center" data-id="element-624" data-mp="1gnctxzwch10z">
        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative h-full min-h-[600px]" data-id="element-625" data-mp="2o056hnu7pa8x">
          <img src="https://cdn.magicpatterns.com/uploads/rmRBKPFnK2E6dvb91taoLe/10_SunsettingCanyon.jpg" alt="Canyon at sunset representing deep conviction and long-term vision in venture investing" className="w-full h-full object-cover" data-id="element-626" data-mp="7ljlbjk2w6u1" />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-black/50" data-id="element-627" data-mp="3otyi97ukjcwr" />
        </motion.div>

        {/* Content */}
        <motion.div initial={{
        opacity: 0,
        x: 50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="p-8 md:p-16 bg-gradient-to-r from-black/50 to-black" data-id="element-628" data-mp="3ktelw6htkdbo">
          <div className="max-w-xl" data-id="element-629" data-mp="asar1mj0m6i4">
            <p className="text-vitalityTeal text-sm font-bold tracking-wider uppercase mb-4" data-id="element-630" data-mp="fqcbaas6gbv6">
              Trait 01
            </p>
            <h2 className="text-5xl font-bold text-white mb-6" data-id="element-631" data-mp="1prt9gu36k2q">Conviction</h2>
            <div className="space-y-4 text-gray-300 leading-relaxed" data-id="element-632" data-mp="6peeodk2j6mm">
              <p className="text-xl" data-id="element-633" data-mp="6rqx0rtqnj07">
                "I am a high conviction leader. I see opportunity in chaos and
                go after seemingly intransigent challenges."
              </p>
              <p data-id="element-634" data-mp="3syyxpgtpr1pw">
                That conviction is encoded in DNA. My grandparents were shipped
                to Siberian labor camps and came to the United States as
                refugees to start over. I come by my relentless drive and
                endurance honestly.
              </p>
              <p data-id="element-635" data-mp="359w6bh9a1ui7">
                This experience shapes every investment decision, every founder
                conversation, every nearly impossible goal we pursue.
              </p>
            </div>

            <div className="mt-8 pt-8 border-t border-white/10" data-id="element-636" data-mp="2qmnxuo7cs39x">
              <p className="text-white font-semibold mb-3" data-id="element-637" data-mp="2lnb37ha8prws">Heritage → Action</p>
              <p className="text-gray-400 text-sm" data-id="element-638" data-mp="30k21toc3azlc">
                From Siberian labor camps to building a $75M global fund
                addressing forced labor risks. The circle completes itself
                through conviction.
              </p>
            </div>
          </div>
        </motion.div>
      </article>

      {/* Trait 2: Resilience */}
      <article aria-label="Trait: Resilience" className="min-h-screen grid lg:grid-cols-2 items-center" data-id="element-639" data-mp="3j9ih5hsfowlt">
        {/* Content */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="p-8 md:p-16 bg-gradient-to-l from-black/50 to-black order-2 lg:order-1" data-id="element-640" data-mp="3ebqim4xaac8n">
          <div className="max-w-xl ml-auto" data-id="element-641" data-mp="4606a4bn7049">
            <p className="text-vitalityTeal text-sm font-bold tracking-wider uppercase mb-4" data-id="element-642" data-mp="94v0e2f28b3o">
              Trait 02
            </p>
            <h2 className="text-5xl font-bold text-white mb-6" data-id="element-643" data-mp="dwd06n5ck5n2">Resilience</h2>
            <div className="space-y-4 text-gray-300 leading-relaxed" data-id="element-644" data-mp="hxessl4rdjg2">
              <p className="text-xl" data-id="element-645" data-mp="hz9bdssk4zgz">
                I spent 10 years building and deploying a $75M global fund in
                the face of political headwinds from conception to getting money
                on the ground.
              </p>
              <p data-id="element-646" data-mp="wt4gcnple4mw">
                Resilience requires navigating when the path disappears. It's
                conducting risk assessments in Myanmar, Indonesia, the
                Philippines, and India. It's leading organizational
                transformation through CEO transition and reduction of force
                post-Covid.
              </p>
              <p data-id="element-647" data-mp="1azpmq6y84294">
                It's standing at the Moab 240 start line knowing David Goggins—a
                former Navy SEAL—DNF'd this race on his first attempt. And
                finishing anyway. 8th place female.
              </p>
            </div>

            <div className="mt-8 pt-8 border-t border-white/10" data-id="element-648" data-mp="120krpalver1p">
              <p className="text-white font-semibold mb-3" data-id="element-649" data-mp="1ypjyel6t3krs">
                10-Year Track Record
              </p>
              <ul className="space-y-2 text-gray-400 text-sm" data-id="element-650" data-mp="1uoq85l5w5tvq">
                <li data-id="element-651" data-mp="1poc0w5c46nyr">
                  • $75M raised from family offices, foundations, governments
                </li>
                <li data-id="element-652" data-mp="1kqahfjas0mmr">• 40 projects deployed globally</li>
                <li data-id="element-653" data-mp="1krvdjdcqodmq">
                  • Led through political headwinds and organizational
                  transformation
                </li>
                <li data-id="element-654" data-mp="9a2lw1tribkl">• Served as Director, Managing Director, and President</li>
                <li data-id="element-655" data-mp="29cv9itzbegbr">
                  • Managed global teams through audits, reporting to diverse
                  funders, and delivering on KPIs
                </li>
              </ul>
            </div>
          </div>
        </motion.div>

        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        x: 50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative h-full min-h-[600px] order-1 lg:order-2" data-id="element-656" data-mp="1zgif1tvy3yfy">
          <img src="https://cdn.magicpatterns.com/uploads/jFhgLpSVhVCK824V85YJZE/1_Moab_Start_line.jpg" alt="Natalya Wallin at the Moab 240-mile ultramarathon start line — resilience in action" className="w-full h-full object-cover" data-id="element-657" data-mp="2ib7394vh9u8f" />
          <div className="absolute inset-0 bg-gradient-to-l from-transparent to-black/50" data-id="element-658" data-mp="3ftysrby3ydjd" />
        </motion.div>
      </article>

      {/* Trait 3: Execution */}
      <article aria-label="Trait: Execution" className="min-h-screen grid lg:grid-cols-2 items-center" data-id="element-659" data-mp="zfdl8agwd8my">
        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative h-full min-h-[600px]" data-id="element-660" data-mp="1e5krzsxjl37t">
          <img src="https://cdn.magicpatterns.com/uploads/mworPtjEMYJXiYJ2sRbKWX/2_LeadvilleFinish.jpg" alt="Natalya Wallin finishing the Leadville 100-mile endurance run — top 30 female finisher" className="w-full h-full object-cover" data-id="element-661" data-mp="ugk8ik9fplnu" />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-black/50" data-id="element-662" data-mp="21tu8qgfwf0s3" />

          {/* Image overlay text */}
          <div className="absolute bottom-8 left-8 right-8" data-id="element-663" data-mp="t2yrpaaab0sk">
            <p className="text-white text-sm mb-1" data-id="element-664" data-mp="p1d8z8b2jsag">
              Leadville 100 Mile Endurance Run
            </p>
            <p className="text-white/60 text-xs" data-id="element-665" data-mp="ka4xm6q6hwun">
              Top 30 Female Finisher • 30+ Hour Race
            </p>
          </div>
        </motion.div>

        {/* Content */}
        <motion.div initial={{
        opacity: 0,
        x: 50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="p-8 md:p-16 bg-gradient-to-r from-black/50 to-black" data-id="element-666" data-mp="adidxl9l9bu7">
          <div className="max-w-xl" data-id="element-667" data-mp="1vqlhqdcoh1nu">
            <p className="text-vitalityTeal text-sm font-bold tracking-wider uppercase mb-4" data-id="element-668" data-mp="1vpk3y14a212f">
              Trait 03
            </p>
            <h2 className="text-5xl font-bold text-white mb-6" data-id="element-669" data-mp="1yariyd9wqe0p">Execution</h2>
            <div className="space-y-4 text-gray-300 leading-relaxed" data-id="element-670" data-mp="1y8nglzrnpn2j">
              <p className="text-xl" data-id="element-671" data-mp="238jklz0ctei3">
                Conviction without execution is just noise. Resilience without
                results is just stubbornness.
              </p>
              <p data-id="element-672" data-mp="2czxjq5oe8cap">
                I successfully completed the Moab 240-miler. Top 30 female
                finisher at Leadville 100. LifeTime Foundation athlete. These
                are examples of execution under extreme conditions.
              </p>
              <p data-id="element-673" data-mp="1kcth27crwa23">
                In fund management: developed criteria, diligence processes, and
                review systems. Deployed $75M across 40 projects. Reported to
                Board of Directors. Engaged auditors. Led organizational change.
                Delivered results.
              </p>
            </div>

            <div className="mt-8 pt-8 border-t border-white/10" data-id="element-674" data-mp="34qak453kokrc">
              <p className="text-white font-semibold mb-3" data-id="element-675" data-mp="34sohiklq6922">
                Execution = Results
              </p>
              <div className="grid grid-cols-2 gap-4" data-id="element-676" data-mp="10mz7rrrfbq27">
                <div data-id="element-677" data-mp="10mh2y6qp43io">
                  <p className="text-3xl font-bold text-vitalityTeal mb-1" data-id="element-678" data-mp="10pbpq4x6m0f9">
                    240
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-679" data-mp="19nx4rq3g2xba">Miles Completed</p>
                </div>
                <div data-id="element-680" data-mp="ly2vfiic3qvs">
                  <p className="text-3xl font-bold text-vitalityTeal mb-1" data-id="element-681" data-mp="lxb9kzejh7ip">
                    $75M
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-682" data-mp="hxsl5tnieeb4">Capital Deployed</p>
                </div>
                <div data-id="element-683" data-mp="vonz3kcv7llk">
                  <p className="text-3xl font-bold text-vitalityTeal mb-1" data-id="element-684" data-mp="vp7aei80fbqm">
                    Top 30
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-685" data-mp="37ldm8z1ifp7">Leadville Finish</p>
                </div>
                <div data-id="element-686" data-mp="3udw9zrt3usa7">
                  <p className="text-3xl font-bold text-vitalityTeal mb-1" data-id="element-687" data-mp="3uefunga53urx">
                    40
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-688" data-mp="29usr3i72jczv">Projects Funded</p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </article>

      {/* Trait 4: Vision */}
      <article aria-label="Trait: Vision" className="min-h-screen grid lg:grid-cols-2 items-center" data-id="element-689" data-mp="20wql0o8h9u5q">
        {/* Content */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="p-8 md:p-16 bg-gradient-to-l from-black/50 to-black order-2 lg:order-1" data-id="element-690" data-mp="2tk49rz20vjer">
          <div className="max-w-xl ml-auto" data-id="element-691" data-mp="186rq4c7lr2t5">
            <p className="text-vitalityTeal text-sm font-bold tracking-wider uppercase mb-4" data-id="element-692" data-mp="184x5kz08tcpl">
              Trait 04
            </p>
            <h2 className="text-5xl font-bold text-white mb-6" data-id="element-693" data-mp="1d38gze66rv9x">Vision</h2>
            <div className="space-y-4 text-gray-300 leading-relaxed" data-id="element-694" data-mp="1sgj4tui3mq80">
              <p className="text-xl" data-id="element-695" data-mp="1nngk8bvaur3y">
                Applying an ultrarunner mindset to investing in a world of
                vitality.
              </p>
              <p data-id="element-696" data-mp="1entjlsae9pby">
                Based on the Biophilia Hypothesis and tapping into backgrounds
                in biology, molecular genetics, and corporate sustainability,
                we're building Vitality—a fund that invests in a vibrant planet
                and human health through biomimicry.
              </p>
              <p data-id="element-697" data-mp="22cw6pfnssadu">
                This is the long run. Not quarters. Not years. Decades. Building
                a multidisciplinary, unconventional team for challenges that
                don't have obvious solutions yet.
              </p>
            </div>

            <div className="mt-8 pt-8 border-t border-white/10" data-id="element-698" data-mp="qvw7s16y2xau">
              <p className="text-white font-semibold mb-3" data-id="element-699" data-mp="lye4aqbp5aa8">Foundation</p>
              <ul className="space-y-2 text-gray-400 text-sm" data-id="element-700" data-mp="bw0h6oqr80eu">
                <li data-id="element-701" data-mp="bted4z32o31d">• Biology & Molecular Genetics background</li>
                <li data-id="element-702" data-mp="guttwey7vndy">• Executive MBA, Duke University</li>
                <li data-id="element-703" data-mp="lsvfb6j47ysl">• MPP, University of Chicago</li>
                <li data-id="element-704" data-mp="ls3u8pn59jgk">• Forte Fellow</li>
              </ul>
            </div>
          </div>
        </motion.div>

        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        x: 50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative h-full min-h-[600px] order-1 lg:order-2" data-id="element-705" data-mp="ulz05zw3bdx9">
          <img src="https://cdn.magicpatterns.com/uploads/hG6wRmeXbcpGUWshNGVPem/9_Descending_Jacobs_Ladder.jpg" alt="Natalya Wallin navigating rugged terrain — vision for long-term nature-inspired investing" className="w-full h-full object-cover" data-id="element-706" data-mp="36bj61ybybt9o" />
          <div className="absolute inset-0 bg-gradient-to-l from-transparent to-black/50" data-id="element-707" data-mp="2yatolwj0pfhh" />
        </motion.div>
      </article>

      {/* Closing Statement */}
      <section className="py-32 bg-black" data-id="element-708" data-mp="3d95m25e7ss9p">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-709" data-mp="38883hrpalw7o">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center" data-id="element-710" data-mp="38aubfsg3idqf">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-8" data-id="element-711" data-mp="3w06gcg4e3zmx">
              Natalya Wallin
            </h2>
            <p className="text-xl text-vitalityTeal mb-6" data-id="element-712" data-mp="8t4fa6l0jszl">
              GP & Managing Director, Vitality VC
            </p>
            <p className="text-2xl text-gray-300 leading-relaxed max-w-3xl mx-auto" data-id="element-713" data-mp="4t2avpnw8lgm">
              Conviction. Resilience. Execution. Vision.
            </p>
          </motion.div>
        </div>
      </section>
    </div>;
}